module.exports = __webpack_public_path__ + "img/sign-out.d2faf716.svg";